const invoicePay = () => {
  try {
    let items = document.querySelectorAll('input[name="offer[payment_name]"]');
    let invoice_fields = document.querySelectorAll('.customkey_invoiceP');

    for(let i = 0; i < invoice_fields.length; i++) {
      invoice_fields[i].style.display = 'none';
    }

    for(let i = 0; i < items.length; i++) {
      if(items[i].checked == true && items[i].value == '請求書払い') {
        for(let i = 0; i < invoice_fields.length; i++) {
          invoice_fields[i].style.display = 'flex';
        }
      }

      items[i].addEventListener('click', function(){
        if(items[i].value == '請求書払い') {
          for(let i = 0; i < invoice_fields.length; i++) {
            invoice_fields[i].style.display = 'flex';
            invoice_fields[i].querySelector('input').required = true;
          }
        }
        else {
          for(let i = 0; i < invoice_fields.length; i++) {
            invoice_fields[i].style.display = 'none';
            invoice_fields[i].querySelector('input').required = false;
          }
        }
      });
    }

  } catch (error) {
    console.log(error);
  }
}

export default invoicePay